/**
 * Baseline capability blob — the fallback when no role or user row exists.
 * This is the single source of truth for out-of-the-box permissiveness.
 *
 * Values:
 *   'allow'     — permitted, thread sandbox decides whether to prompt
 *   'never_ask' — permitted, skip approval prompts
 *   'deny'      — blocked
 */

const PIEVE_CAPABILITY_DEFAULTS = Object.freeze({
  shell: {
    default: 'allow'
  },
  files: {
    default: 'allow',
    read: 'never_ask'
  },
  apps: {
    default: { read: 'never_ask', create: 'allow', update: 'allow', delete: 'allow', unknown: 'allow' }
  },
  webSearch: 'never_ask'
});

export { PIEVE_CAPABILITY_DEFAULTS };
